// Sidenav
jQuery('.burger-menu, .close-menu').on('click', function () {
  let sidenav = jQuery('#mySidenav');
  sidenav.toggleClass('open');
  if (sidenav.hasClass('open')) {
    jQuery('body').css('overflow', 'hidden');
    jQuery('.burger-menu').each(function() {
      jQuery(this).attr('aria-expanded', true);
    });
    // trapper.init();
  } else {
    jQuery('body').css('overflow', 'auto');
    jQuery('.burger-menu').each(function() {
      jQuery(this).attr('aria-expanded', false);
    });
    // trapper.dismiss();
  }
});

jQuery('.portal__burger-menu').on('click', function() {
  let portalMenu = jQuery('#portalSidenav');
  portalMenu.toggleClass('open');
  if (portalMenu.hasClass('open')) {
    jQuery('body').css('overflow', 'hidden');
    jQuery('.portal__burger-menu').each(function() {
      jQuery(this).attr('aria-expanded', true);
    });
  } else {
    jQuery('body').css('overflow', 'auto');
    jQuery('.portal__burger-menu').each(function() {
      jQuery(this).attr('aria-expanded', false);
    });
  }
});
